import { WorkflowType } from './App';

export type CalendarProvider = {
  [key: string]: {
    name: string;
    icon: string;
    app: string;
  };
};

export const allCalendarProviders: CalendarProvider = {
  outlook: {
    name: 'Microsoft Outlook',
    icon: '/calendars/outlook.svg',
    app: 'outlook',
  },
  google: {
    name: 'Google Calendar',
    icon: '/calendars/google.svg',
    app: 'google',
  },
};

export const supportedCalendarProviders: CalendarProvider =
  allCalendarProviders;

export type CalendarStateData = {
  id?: string;
  app?: string;
  workflow?: WorkflowType;
  expirationDays?: number;
};
